import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GamificationCardsService } from '../../../services/gamification-cards.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { ErrorNotficationComponent } from '../../../error-notfication/error-notfication.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-most-used-prompts-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule,MatProgressSpinnerModule, FormsModule, NgMultiSelectDropDownModule, MatCardModule, MatTableModule, MatSelectModule, MatInputModule, MatFormFieldModule, MatPaginatorModule, MatSortModule, MatDividerModule],
  templateUrl: './most-used-prompts-dialog.component.html',
  styleUrl: './most-used-prompts-dialog.component.scss'
})
export class MostUsedPromptsDialogComponent {

  displayedColumns: string[] = [
    'rank',
    'prompt_name',
    'usage',
    'consumers',
    'average_rating'
  ];
  sort_order: string = 'desc';
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator = {} as MatPaginator;
  totalRecords: any = 0;
  pageSize: number = 20;
  pageIndex: number = 0;
  pageSizeOptions: number[] = [5, 10, 20];
  pageNumbers: number[] = [];
  mostUsedPromptsData: any;
  searchtextData: string = '';
  search_text: string = '';
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  usageAscSort: boolean = true;
  usageDesSort: boolean = false;
  sort_by: string = '';
  currentPage: number = 0;
  isLoading:boolean=false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly dialogRef: MatDialogRef<MostUsedPromptsDialogComponent>,
      private readonly gamificationService: GamificationCardsService,
      private readonly dialog: MatDialog,
    ){
  
    }

    ngOnInit() {
      this.getMostUsedPrompts();
    }

    getMostUsedPrompts() {
      this.isLoading=true;
      let categories = this.data?.categories;
      let subcategories = this.data?.subcategories
      const params: any = {
        end_date: this.data?.end_date,
        search_text: this.search_text,
        offset: (this.pageSize * this.pageIndex),
        limit: this.pageSize,
        sort_order: this.sort_order,
        count: false
      }
      const payload: any = {
        categories,
        subcategories
      }
      this.gamificationService.getMostUsedPrompts(params,payload).subscribe({
        next: (resp:any) => {
        this.isLoading=false;
        this.mostUsedPromptsData = resp?.data?.data;
        this.dataSource.data = this.mostUsedPromptsData.map((item: any, index: number) => ({
          ...item,
          // serial: this.currentPage * this.pageSize + index + 1
        }));
        this.totalRecords = resp?.data?.total;
        const totalPages = Math.ceil(this.totalRecords / this.pageSize);
        this.pageNumbers = Array.from({ length: totalPages }, (_, i) => i);
      },error: (error:any) => {
        this.isLoading=false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }})
    }

    onPageChange(event: any) {
   
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.currentPage = event.pageIndex;
      this.getMostUsedPrompts();
    }

    onPageChangeFromDropdown(event: any) {
 
      
      this.pageIndex = event.value;
      this.currentPage = this.pageIndex;
      this.getMostUsedPrompts();
    }

    onSearchChange() {
      if (this.searchtextData == '') {
        this.search_text = this.searchtextData;
        this.getMostUsedPrompts();
      }
    }

    searchData(data:any) {
      if(data == '') {
        return
      } else {
        this.search_text = data;
        this.pageIndex = 0;
        this.getMostUsedPrompts();
      }
    }

    clearSearch() {
      if (this.searchInput) {
        this.searchtextData = '';
        this.search_text = '';
        this.pageIndex = 0;
        this.getMostUsedPrompts();
      }
    }

    sortingByAsc(sortColumn:any) {
      this.pageIndex = 0;
      if (sortColumn == 'usage') {
        this.usageAscSort = false;
        this.usageDesSort = true;
        this.sort_order = 'asc';
        this.getMostUsedPrompts();
      }
    }

    sortingByDes(sortColumn:any) {
      this.pageIndex = 0;
      if (sortColumn == 'usage') {
        this.usageDesSort = false;
        this.usageAscSort = true;
        this.sort_order = 'desc';
        this.getMostUsedPrompts();
      }
    }

    closeDialog() {
      this.dialogRef.close();
    }

    openSnackbar(message: string, title: string, cssClass: string) {
      this.dialog.open(ErrorNotficationComponent, {
        data: {
          message: message,
          title: title,
          action_type: 'add',
          cssClass: cssClass,
        },
      });
    }
}
